import { c as _c } from "react/compiler-runtime";
import { cva } from 'class-variance-authority';
import { format, getDay, getWeekOfMonth, isAfter, isBefore, isSameDay, isSameMonth, isToday, lastDayOfMonth, parse, startOfMonth } from 'date-fns';
import type { DayButtonProps } from '../../date-selector-sheet.types';
const dayButton = cva('all-unset relative flex h-full w-full min-h-10 min-w-10 items-center justify-center text-caption-1 cursor-pointer isolate', {
  variants: {
    isDisabled: {
      true: 'cursor-not-allowed pointer-events-none text-quaternary/50',
      false: 'text-primary'
    },
    isSameMonth: {
      true: 'text-primary',
      false: 'text-tertiary'
    },
    isSelectionStart: {
      true: 'rounded-full bg-accent text-quinary hover:bg-accent/90'
    },
    isSelectionEnd: {
      true: 'rounded-full bg-accent text-quinary hover:bg-accent/90'
    },
    isInRange: {
      true: ''
    },
    isFirstDayOfMonth: {
      true: ''
    },
    isLastDayOfMonth: {
      true: ''
    },
    hasRange: {
      true: ''
    }
  },
  compoundVariants: [{
    isInRange: true,
    isSelectionStart: false,
    isSelectionEnd: false,
    isFirstDayOfMonth: false,
    isLastDayOfMonth: false,
    className: 'bg-accent/10 hover:before:absolute hover:before:inset-0 hover:before:bg-accent/20 hover:before:rounded-full hover:before:w-full hover:before:z-10'
  }, {
    isSelectionStart: true,
    hasRange: true,
    isFirstDayOfMonth: false,
    isLastDayOfMonth: false,
    className: 'before:absolute before:left-[50%] before:top-0 before:right-0 before:bottom-0 before:w-5 before:bg-gradient-to-r before:from-transparent before:to-accent/10 before:z-50'
  }, {
    isSelectionEnd: true,
    hasRange: true,
    isFirstDayOfMonth: false,
    isLastDayOfMonth: false,
    className: 'before:absolute before:left-0 before:top-0 before:right-[50%] before:bottom-0 before:w-5 before:bg-gradient-to-l before:from-transparent before:to-accent/10 before:z-50'
  }, {
    isInRange: false,
    isSelectionStart: false,
    isSelectionEnd: false,
    isFirstDayOfMonth: false,
    isLastDayOfMonth: false,
    className: 'hover:before:absolute hover:before:inset-0 hover:before:bg-hover-control hover:before:rounded-full hover:before:w-full hover:before:z-[0] [&>time]:z-[1] [&>time]:relative'
  }, {
    isInRange: true,
    isSelectionStart: false,
    isSelectionEnd: false,
    isFirstDayOfMonth: true,
    isLastDayOfMonth: false,
    className: 'bg-gradient-to-r from-transparent to-accent/10'
  }, {
    isInRange: true,
    isSelectionStart: false,
    isSelectionEnd: false,
    isFirstDayOfMonth: false,
    isLastDayOfMonth: true,
    className: 'bg-gradient-to-l from-transparent to-accent/10'
  }]
});
const DayButton = t0 => {
  const $ = _c(52);
  const {
    day,
    activeStartDate,
    activeEndDate,
    visibleMonth,
    onClick,
    disabled
  } = t0;
  let t1;
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== activeEndDate || $[1] !== activeStartDate || $[2] !== day || $[3] !== disabled || $[4] !== visibleMonth) {
    const firstDayCurrentMonth = parse(visibleMonth, "MMM-yyyy", new Date());
    let t11;
    if ($[15] !== activeEndDate || $[16] !== activeStartDate) {
      t11 = activeStartDate && activeEndDate && (isBefore(activeStartDate, activeEndDate) || isBefore(activeEndDate, activeStartDate));
      $[15] = activeEndDate;
      $[16] = activeStartDate;
      $[17] = t11;
    } else {
      t11 = $[17];
    }
    const hasRange = t11;
    let t12;
    if ($[18] !== activeEndDate || $[19] !== activeStartDate || $[20] !== day || $[21] !== hasRange) {
      t12 = hasRange && (isBefore(day, activeEndDate) && isAfter(day, activeStartDate) || isBefore(day, activeStartDate) && isAfter(day, activeEndDate));
      $[18] = activeEndDate;
      $[19] = activeStartDate;
      $[20] = day;
      $[21] = hasRange;
      $[22] = t12;
    } else {
      t12 = $[22];
    }
    const isInRange = t12;
    const isStart = activeStartDate && isSameDay(day, activeStartDate);
    const isEnd = activeEndDate && isSameDay(day, activeEndDate);
    const isFirstDayOfMonth = isSameDay(day, startOfMonth(firstDayCurrentMonth));
    const isLastDayOfMonth = isSameDay(day, lastDayOfMonth(firstDayCurrentMonth));
    const isSameMonthDay = isSameMonth(day, firstDayCurrentMonth);
    let t13;
    if ($[23] !== day) {
      t13 = isToday(day);
      $[23] = day;
      $[24] = t13;
    } else {
      t13 = $[24];
    }
    const isCurrentDay = t13;
    const getRow = targetDay => {
      const lastDay = lastDayOfMonth(firstDayCurrentMonth);
      if (isAfter(targetDay, lastDay)) {
        return getWeekOfMonth(lastDay);
      }
      if (isBefore(targetDay, firstDayCurrentMonth)) {
        return 1;
      }
      return getWeekOfMonth(day);
    };
    const getColumn = _temp;
    const gridColumn = getColumn(day) + 1;
    const gridRow = getRow(day);
    t1 = "button";
    t2 = isCurrentDay;
    t3 = isSameMonthDay;
    t4 = isInRange;
    t5 = isStart;
    t6 = isEnd;
    t7 = isFirstDayOfMonth;
    t8 = isLastDayOfMonth;
    t9 = {
      gridColumn,
      gridRow
    };
    t10 = dayButton({
      isDisabled: disabled,
      isSameMonth: isSameMonthDay,
      isSelectionStart: isStart,
      isSelectionEnd: isEnd,
      isInRange: !!isInRange,
      isFirstDayOfMonth: isFirstDayOfMonth && !!isInRange,
      isLastDayOfMonth: isLastDayOfMonth && !!isInRange,
      hasRange: !!hasRange
    });
    $[0] = activeEndDate;
    $[1] = activeStartDate;
    $[2] = day;
    $[3] = disabled;
    $[4] = visibleMonth;
    $[5] = t1;
    $[6] = t10;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t1 = $[5];
    t10 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
    t7 = $[12];
    t8 = $[13];
    t9 = $[14];
  }
  let t11;
  if ($[25] !== day || $[26] !== onClick) {
    t11 = e => onClick(e, day);
    $[25] = day;
    $[26] = onClick;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== day) {
    t12 = format(day, "MMMM d, yyyy");
    $[28] = day;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  const t13 = `Select ${t12}`;
  let t14;
  if ($[30] !== day) {
    t14 = format(day, "yyyy-MM-dd");
    $[30] = day;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== day) {
    t15 = format(day, "d");
    $[32] = day;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t14 || $[35] !== t15) {
    t16 = <time dateTime={t14}>{t15}</time>;
    $[34] = t14;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== disabled || $[38] !== t1 || $[39] !== t10 || $[40] !== t11 || $[41] !== t13 || $[42] !== t16 || $[43] !== t2 || $[44] !== t3 || $[45] !== t4 || $[46] !== t5 || $[47] !== t6 || $[48] !== t7 || $[49] !== t8 || $[50] !== t9) {
    t17 = <button type={t1} data-is-today={t2} data-is-same-month={t3} data-is-in-range={t4} data-is-selection-start={t5} data-is-selection-end={t6} data-is-first-day-of-month={t7} data-is-last-day-of-month={t8} style={t9} className={t10} onClick={t11} aria-label={t13} disabled={disabled}>{t16}</button>;
    $[37] = disabled;
    $[38] = t1;
    $[39] = t10;
    $[40] = t11;
    $[41] = t13;
    $[42] = t16;
    $[43] = t2;
    $[44] = t3;
    $[45] = t4;
    $[46] = t5;
    $[47] = t6;
    $[48] = t7;
    $[49] = t8;
    $[50] = t9;
    $[51] = t17;
  } else {
    t17 = $[51];
  }
  return t17;
};
export default DayButton;
function _temp(targetDay_0) {
  return getDay(targetDay_0);
}